export default __webpack_public_path__ + "static/media/IMG_3063.33d17103.jpeg";